import { ServerTransactionStatusEnum, TRANSACTION_TYPES } from '@expane/data'

export const checkIsTransactionPaymentInCredit = <
  T extends { type: number; typeVariation?: number | null },
>(
  transaction: T,
) => Boolean(transaction.type === TRANSACTION_TYPES.paymentInCredit.id)

export const checkAreEveryTransactionPaymentInCredit = <
  T extends { type: number; typeVariation?: number | null }[],
>(
  transactions: T,
) =>
  transactions.every(transaction =>
    Boolean(transaction.type === TRANSACTION_TYPES.paymentInCredit.id),
  )

export const checkIsSomeTransactionPaymentInCredit = <
  T extends { type: number; typeVariation?: number | null }[],
>(
  transactions: T,
) => transactions.some(transaction => checkIsTransactionPaymentInCredit(transaction))

export const isThisCompletedTransaction = <T extends { status: ServerTransactionStatusEnum }>(
  transaction: T,
): boolean => transaction.status === ServerTransactionStatusEnum.Completed

export const isThisPendingTransaction = <T extends { status: ServerTransactionStatusEnum }>(
  transaction: T,
): boolean => transaction.status === ServerTransactionStatusEnum.Pending

export const isThisCompletedPaymentTransaction = <
  T extends { status: ServerTransactionStatusEnum; type: number },
>(
  transaction: T,
): boolean =>
  isThisCompletedTransaction(transaction) &&
  (transaction.type === TRANSACTION_TYPES.payment.id ||
    transaction.type === TRANSACTION_TYPES.paymentInCredit.id ||
    transaction.type === TRANSACTION_TYPES.paymentWithProvider.id)
